export default "__VITE_ASSET__DqM9Z_vu__"